import { ChangeDetectorRef, Component, ElementRef, forwardRef, Inject, QueryList, Renderer2, ViewChildren, ViewContainerRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { infoPopUpComponent } from "sharedFeatures/infoPopUp";
import { NewPlanForm, NewPlanFormBodyComponent } from 'sharedFeatures/newplan-win';
import { CreatePlanLoaderPopup } from "sharedFeatures/newplan-win/create-plan-loader-popup";
import { ScrollComponent } from "sharedFeatures/scroll";
import { XeroService } from 'sharedFeatures/sharedServices';
import { DialogCreator } from "sharedFeatures/window";
import { AccountsModel } from 'sharedFeatures/sharedModels/xero/accountsModel';
import { AssociationsModel } from 'sharedFeatures/sharedModels/xero/associationsModel';
import { xeroSettingsActions } from 'sharedFeatures/store';
import { Xi3BalanceSheetBaseComponent } from './xi-3-balancesheet-base.component';
import { DomSmallUtils } from 'sharedGuiSmall/utils/dom-utils';
import { SharedGuiSmallModule } from '../../../../../sharedGuiSmall/sharedGuiSmall.module';
import { MoveBtnComponent } from '../move-btn/move-btn.component';
import { DraggabledDirective, ListDropTargetDirective } from '../../../../directives';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'xi-3-balancesheet-form-body',
    templateUrl: './xi-3-balancesheet-form-body.component.html',
    styleUrls: ['./xi-3-balancesheet-form-body.component.less'] ,
    standalone: true,
    imports: [SharedGuiSmallModule, MoveBtnComponent, DraggabledDirective, ListDropTargetDirective, infoPopUpComponent, TranslateModule]

})
export class Xi3BalanceSheetFormBodyComponent extends Xi3BalanceSheetBaseComponent {

    @ViewChildren(infoPopUpComponent)
    infoPopupItems: QueryList<infoPopUpComponent> | undefined = undefined;

    constructor(
        el: ElementRef,
        r: Renderer2,
        xeroService: XeroService,
        @Inject(forwardRef(() => NewPlanForm)) private parent: NewPlanForm,
        bodyViewRef: ViewContainerRef,
        chDet: ChangeDetectorRef
    ) {
        super(el, r, xeroService, bodyViewRef, chDet);
    }

    getForm(): NgForm {
        return this.form;
    }

    /**
     * Returns current form`s tab:
     * "General Settings", "Finance Settings", "Opening Balance"

    public getSettingTab(): SettingTab {
        return SettingTab.General;
    }*/

    ngOnInit() {

    }

    ngAfterViewInit() {

        super.ngAfterViewInit();

        this.parent.getOnClose().subscribe(this.onParentClose.bind(this));

    }


    public isSaveClosePaneHidden(): boolean {

        return !this.saveClosePane || this.saveClosePane.isHidden();

    }

    loadBSAccounts(): void {

        super.loadBSAccounts(() => { this.parent.close(); }, () => { this.parent.enableContinue(); });

    }

    reloadBSAccounts(): void {

        super.loadBSAccounts();

    }


    public getScrollPane(): ScrollComponent {

        return (<NewPlanFormBodyComponent> this.parent.getBodyComponent()).getScrollPane();

    }

    public closeOtherInfoPanels(id: string) {
        if (this.infoPopupItems)
            this.infoPopupItems.forEach(x => {
                if (x.pFieldID !== id) x.close();
            });
    }

    onClose() {

        this.parent.showSetupWarning();

    }

    protected onParentClose(): void {

        super.onParentClose();
        this.r.setStyle(this.saveClosePanePlaceEl(), 'height', '0px');

    }

    public saveClosePanePlaceEl(): Element {

        return this.parent.getBodyComponent().saveClosePanePlaceEl();

    }

    public getDialogCreator(): DialogCreator {

        return this.parent.getDialogCreator();

    }

    public getParentEl(): Element {

        return this.parent.getElDom();

    }

    onCreatePlan() {
        let parentBody = <NewPlanFormBodyComponent>this.parent.getBodyComponent();

        this.onGoOut(() => {

            this.xeroService.XeroGetComponentAssociations(this.parent.plAccountsData, this.parent.bsAccountsData).then((componentAssociations) => {
                if (typeof (componentAssociations.success) == "undefined") return;

                if (componentAssociations.success) {

                    const ca = componentAssociations.ComponentAssociations;
                    let isExistingAssociations = parentBody.isConnectToExistingModeEnabled;

                    if (isExistingAssociations) {
                        this.xeroService.ConnectXeroPlan(this.getPlanGuid(), () => {
                            this.processConnectCreate(ca, isExistingAssociations, this.parent.plAccountsData!, this.parent.bsAccountsData!);
                        });
                    }
                    else
                        this.processConnectCreate(ca, isExistingAssociations, this.parent.plAccountsData!, this.parent.bsAccountsData!);

                }
                else {
                    this.parent.close();
                }
            });
        });

    }

    protected processConnectCreate(ca: AssociationsModel, isExistingAssociations: boolean, plAccounts: AccountsModel, bsAccounts: AccountsModel) {
        let loadingPopup = <CreatePlanLoaderPopup>this.parent.getDialogCreator().createDialog(CreatePlanLoaderPopup);

        let appElem = document.body;

        let x = (DomSmallUtils.width(appElem) - loadingPopup.width) / 2;
        let y = (DomSmallUtils.height(appElem) - loadingPopup.height) / 2;

        loadingPopup.setModal(true);
        loadingPopup.show(x, y);

        this.xeroService.SetComponentAssociations(ca, plAccounts, bsAccounts).then((data) => {
            if (typeof (data.success) == "undefined") return;

            if (data.success)
            {
                xeroSettingsActions.setXeroPLAccounts(data.plAccounts);
                xeroSettingsActions.setXeroBSAccounts(data.bsAccounts);

                if (isExistingAssociations)
                    this.parent.connectExistingPlanToXero(this.getPlanGuid(), () => { document.location.reload(); });
                else
                    this.parent.createPlan(() => { loadingPopup.close(); });
            }
            else {
                loadingPopup.close();
                this.parent.close();
            }
        });
    }
}